import type { RangeDateTypeHr } from 'src/types/date.type';
import type { TicketResponses } from 'src/types/elements.type';
import type { ApprovalStatus } from 'src/types/helpdesk/ticket.type';
import type { IExpenseTrackingRequestTicket } from 'src/types/hr_ticket/expenseTrackingRequestTicket.type';
import type { PagedList } from 'src/types/pagedList.type';
import type { IHrTicketParams } from 'src/types/params.type';
import { http, httpV2 } from '@martech-solution/utils/utils';

const controller = 'hr/expense-tracking-request-tickets';

export const getTickets = async (params: IHrTicketParams) => {
  return await http.get<PagedList<IExpenseTrackingRequestTicket>>(controller, {
    params: params
  });
};

export const getTicket = async (id: number) => {
  return await http.get<IExpenseTrackingRequestTicket>(`${controller}/${id}`);
};

export const cancelTicket = async (id: number) => {
  return await http.put(`${controller}/${id}/cancel`);
};

export const cancelApprovalTickets = async (id: string, step: number) =>
  await http.put(`${controller}/${id}/cancel-approval`, { step });

export const approvalTickets = async (
  ticketResponses: TicketResponses[],
  approvalStatus: ApprovalStatus,
  note?: string
) =>
  await http.put(`${controller}/approvals`, {
    ticketResponses: ticketResponses,
    approvalStatus,
    note: note ? note : ''
  });

export const printTicket = async (id: number) =>
  await http.get(`${controller}/print`, {
    params: {
      id: id
    },
    responseType: 'blob'
  });

export const getTicketsApproval = async (params: IHrTicketParams) => {
  return await http.get<PagedList<IExpenseTrackingRequestTicket>>(`${controller}/waiting-approval`, {
    params: params
  });
};

export const getTicketWaitingProcessingCount = async (params: RangeDateTypeHr) => {
  return await http.get(`${controller}/count-ticket-waiting-processing`, {
    params: params
  });
};

export const getMyTicketCount = async (params: RangeDateTypeHr) => {
  return await http.get(`${controller}/count-my-tickets`, {
    params: params
  });
};

export const getTicketApprovalCount = async (params: RangeDateTypeHr) => {
  return await http.get(`${controller}/count-handle-tickets`, {
    params: params
  });
};

export const getTicketHrConfirmCount = async (params: RangeDateTypeHr) => {
  return await httpV2.get(`${controller}/count-hr-confirm-tickets`, {
    params: params
  });
};
